import { Capacitor } from "@capacitor/core";

// Base web pubblica (stessa logica di ShareIcon): serve alla pagina ponte del player su app nativa
const PUBLIC_WEB_URL = 'https://ticinowild.ch';

function getYoutubeEmbed(htmlText) {
    // RegEx per trovare i link di YouTube e rimuovere query string
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^"&?/\s]{11})/g;

    // Funzione di sostituzione per convertire il link in iframe
    const replaceWithIframe = (match, prefix, videoId) => {
        // Su app nativa si passa dalla pagina ponte public/yt-embed.html sul dominio pubblico,
        // che carica il player da un documento https vero (Referer valido). Motivo: su iOS
        // l'origin della webview (capacitor://localhost) non produce alcun Referer HTTP e
        // YouTube rifiuta l'embed diretto con "Errore 153"; su Android l'origin https://localhost
        // oggi passa, ma è un referer arbitrario che YouTube potrebbe iniziare a rifiutare →
        // ponte per entrambe le piattaforme. Su web embed diretto come sempre.
        const src = Capacitor.isNativePlatform()
            ? `${PUBLIC_WEB_URL}/yt-embed.html?v=${videoId}`
            : `https://www.youtube.com/embed/${videoId}`;
        return `
            <iframe class="youtube-responsive-iframe" src="${src}"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>`;
    };

    // Sostituzione dei link di YouTube con i relativi iframe
    return htmlText.replace(youtubeRegex, replaceWithIframe);
}

export default getYoutubeEmbed
